module.exports = __webpack_public_path__ + "img/mirror_rounded.190cb2e4.png";